import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgTable = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 20,
	height: 20,
	viewBox: "0 0 20 20",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M16 2C17.1031 2 18 2.95926 18 4.14286V14.8571C18 16.0391 17.1031 17 16 17H4C2.89531 17 2 16.0391 2 14.8571V4.14286C2 2.95926 2.89531 2 4 2H16ZM9 9.5V6.28571H4V9.5H9ZM4 11.6429V14.8571H9V11.6429H4ZM11 14.8571H16V11.6429H11V14.8571ZM16 9.5V6.28571H11V9.5H16Z",
		fill: "#0D2976"
	})
});
export default SvgTable;
